import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Strip markdown formatting from text while preserving readability and structure
 * Removes bold (**text**), italic (*text*), headers (#), and converts list markers
 */
export function stripMarkdown(text: string): string {
  if (!text) return "";
  
  return text
    // Remove bold markers
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    // Remove italic markers
    .replace(/\*([^*]+)\*/g, "$1")
    // Remove headers but keep the text on its own line
    .replace(/^#+\s+/gm, "")
    // Convert bullet list markers to bullet points
    .replace(/^[-*+]\s+/gm, "• ")
    // Keep numbered list markers as-is (they're readable)
    // Clean up multiple spaces on the same line (but preserve newlines)
    .replace(/[^\S\n]+/g, " ")
    // Ensure consistent paragraph breaks (collapse 3+ newlines to 2)
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

/**
 * Format plan name to capitalize first letter
 * @param plan - Plan name in lowercase
 * @returns Capitalized plan name
 */
export function formatPlanName(plan: 'starter' | 'professional' | 'business'): string {
  return plan.charAt(0).toUpperCase() + plan.slice(1);
}
